import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initVersionCheck } from "@/utils/versionCheck";

// Ativa polling de nova versao apos deploy — forca reload automatico
// quando detectar que o build remoto e diferente do carregado.
initVersionCheck();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
